import React from 'react';

import { Spacer, Title, Message } from 'src/core/components';

import { ProgressTabs } from 'src/components/OligoDNA/components';
import { DNA, COUNTRY_CODE_JAPAN } from 'src/constants/forms';
import { DnaOligo } from 'src/models';
import { getCountryCode } from 'src/utils';
import messages from './messages';

import './OligoDNAStyle.scss';

const OligoDNA = () => {
  let value = DNA;
  const dnaType = DnaOligo.getDNAType();

  if (dnaType) {
    value = `Ampliseq ${DnaOligo.getAmpliseqType(dnaType)}`;
  }

  let message = { ...messages.filesInstructions, values: { value } };

  if (getCountryCode() === COUNTRY_CODE_JAPAN) {
    message = { ...messages.japanFilesInstructions, values: { value } };
  }

  return (
    <>
      <Spacer top={20} bottom={8}>
        <Title size="1" font="thin" message={{ ...messages.title, values: { value } }} />
      </Spacer>
      <div className="dna-files-details">
        <div className="dna-files-details__description">
          <Message message={message} />
        </div>
      </div>
      <Spacer bottom={48} />
      <ProgressTabs dnaType={dnaType} />
    </>
  );
};

export default OligoDNA;
